import { Avatar as MuiAvatar } from '@mui/material';

const styles = {
    small: {
        height: '29px',
        width: '29px',
        margin: '0 auto',
        background: '#003DA6',
        fontSize:'14px',
    },
    default: {
        height: '39px',
        width: '39px',
        margin: '0 auto',
        background: '#003DA6',
        border: '3.26px solid #0056ED',
        fontSize:'16px',
    },
    medium: {
        height: '50px',
        width: '50px',
        margin: '0 auto',
        border: '3.26px solid #0056ED',
        background: '#003DA6',
    },
    large: {
        height: '96px',
        width: '96px',
        margin: '0 auto',
        border: '5px solid #196CFD',
        background: '#003DA6',
        fontSize:'40px',
    },
    xlarge: {
        height: '160px',
        width: '160px',
        margin: '0 auto',
        background: '#003DA6',
    }
};

interface AvatarProps {
    firstName: string;
    lastName: string;
    avatarImg?: string;
    size: 'large' | 'default' | 'medium' | 'xlarge' | 'small';
}

const Avatar = (props: AvatarProps) => {
    const firstName = props.firstName;
    const lastName = props.lastName;
    const fullName = `${firstName} ${lastName}`.replace(/"/g, '');
    const initials = firstName.charAt(0) + lastName.charAt(0);
    return (
        <>
            {props.avatarImg ? (
                <MuiAvatar
                    alt={fullName}
                    src={props.avatarImg}
                    sx={styles[props.size]}
                />
            ) : (
                <MuiAvatar sx={{...styles[props.size]}}>{initials}</MuiAvatar>
            )}
        </>
    );
};

Avatar.defaultProps = {
    size: 'default',
};

export default Avatar;
